import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import useTranslate from '../../../core/languages/hooks/useTranslate';
import InputField from '../../../ui/components/InputField/InputField';
import { getTransportTimeLabel } from '../../utils/transportLabels';

interface TransportTimeProps {
    name: string; // "arrivalTransportTime" or "departureTransportTime"
    transportFieldName: string; // "arrivalTransport" or "departureTransport" to get dynamic label
    direction: 'arrival' | 'departure';
    dateFieldName: string; // "arrivalTransportDate" or "departureTransportDate" to validate time
}

/**
 * Reusable component for transport time field
 * Only receives the field name
 */
const TransportTime: React.FC<TransportTimeProps> = ({ name, transportFieldName, direction, dateFieldName }) => {
    const t = useTranslate();
    const { control, formState: { errors }, watch } = useFormContext();
    const transport = watch(transportFieldName);
    const selectedDate = watch(dateFieldName);

    const validateTimeForToday = (time: string): boolean | string => {
        if (!time || !selectedDate) return true;

        const selectedMoment = moment(selectedDate);
        const today = moment().startOf('day');

        // Solo validar hora si la fecha seleccionada es hoy
        if (selectedMoment.isSame(today, 'day')) {
            const [hours, minutes] = time.split(':').map(Number);
            const selectedTime = moment().hours(hours).minutes(minutes);
            const currentTime = moment();

            if (selectedTime.isBefore(currentTime)) {
                return t("common.feedback.time_cannot_be_in_past");
            }
        }

        return true;
    };

    return (
        <Controller
            name={name}
            control={control}
            rules={{
                required: t("common.feedback.field_required"),
                validate: validateTimeForToday
            }}
            render={({ field }) => (
                <InputField
                    {...field}
                    label={getTransportTimeLabel(t, transport, direction)}
                    type="time"
                    error={(errors as any)[name]?.message}
                />
            )}
        />
    );
};

export default TransportTime;

